import { __rest } from "tslib";
import * as React from 'react';
const CheckXSmall = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 16 16", fill: "currentColor", width: size || "16", height: size || "16" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M6.7847,10.9609 L6.07759322,10.2537932 L6.0777,10.2537932 L3.9997,8.1759 L4.70680678,7.46879322 L6.7847,9.54679322 L11.2925932,5.03879322 L11.9997,5.7459 L6.7847,10.9609 Z" })));
};
CheckXSmall.displayName = 'CheckXSmall';
export default CheckXSmall;
//# sourceMappingURL=CheckXSmall.js.map